// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__3AP8y","icon":"SortAdornment_icon__1Q0Ql","up":"SortAdornment_up__NMmsb","down":"SortAdornment_down__wQMN8","active":"SortAdornment_active__3fsPQ"};